/**
 * Methods for calculating coefficient.
 */
/** @private */
export function rangeValueToCoefficient(value, range, inversed) {
    const result = (value - range.min) / (range.delta);
    return inversed ? (1 - result) : result;
}
/** @private */
export function getXLocation(x, range, size, inversed) {
    x = rangeValueToCoefficient(x, range, inversed);
    return x * size;
}
/** @private */
export function getRangeValueXByPoint(value, size, range, inversed) {
    const actualValue = !inversed ? value / size : (1 - (value / size));
    return actualValue * (range.delta) + range.min;
}
/** @private */
export function getExactData(points, start, end) {
    const selectedData = [];
    points.map((point) => {
        if (point.xValue >= start && point.xValue <= end) {
            selectedData.push({
                'x': point.x,
                'y': point.y
            });
        }
    });
    return selectedData;
}
/** @private */
export function getNearestValue(values, point) {
    return values.reduce((prev, curr) => {
        return (Math.abs(curr - point) < Math.abs(prev - point) ? curr : prev);
    });
}
/**
 * Data point
 *
 * @public
 */
export class DataPoint {
    // eslint-disable-next-line @typescript-eslint/no-inferrable-types
    constructor(x, y, xValue, yValue, visible = true) {
        this.x = x;
        this.y = y;
        this.xValue = xValue;
        this.visible = visible;
    }
}
